module.exports = __webpack_public_path__ + "static/freetrade-01dbd75eb015c60673de9c7fc8df0fbf.png";